import './index.css'
import * as React from 'react'
import HelpTooltip from 'components/common/tooltip'
import { Text } from 'components/ds'
import ChangeIndicator from './change-indicator'
type FormFieldOptions = {
  showIcon?: boolean
  tooltipId?: string
  tooltipContents?: string
}
type Props = {
  beforeLabel?: React.ReactNode
  className?: string
  fieldName: string
  label: string
  options: FormFieldOptions
  helpText?: React.ReactNode
  component: React.ReactNode
  showDifference: boolean | null | undefined
  metadata: Record<string, any>
  originalMetadata: Record<string, any> | null | undefined
}

const FormField = ({
  className,
  beforeLabel,
  helpText,
  fieldName,
  label,
  options,
  metadata,
  originalMetadata,
  component,
  showDifference,
}: Props): React.ReactElement<'div'> => {
  const { showIcon, tooltipId, tooltipContents } = options
  return (
    <div className={className}>
      <Text
        as="label"
        size="1"
        color="gray"
        mb="2"
        className="EditMetadata_Label flc"
        title={label}
      >
        {beforeLabel && (
          <div className="EditMetadata_BeforeLabel">{beforeLabel}</div>
        )}
        {label}
        {(tooltipId || tooltipContents) && (
          <HelpTooltip id={tooltipId}>{tooltipContents}</HelpTooltip>
        )}
        {showIcon && showDifference && (
          <div className="EditMetadata_Label_Icon">
            <ChangeIndicator
              field={fieldName}
              metadata={metadata}
              originalMetadata={originalMetadata}
            />
          </div>
        )}
      </Text>
      {component}
      {helpText}
    </div>
  )
}

export default FormField
